<app-view #view [code]="'origins.edit'" [model]="origin" (onEvent)="onEvent($event)"></app-view>
